/*
 * File: NavigationTab.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 11, 2022 at 12:25 AM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 4, 2025 at 5:31 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled, { css } from 'styled-components';

// Components
import { LocaleLink } from '../LocaleLink';
import { Typography } from '../Typography';
import { xSmallBreakpoint } from '../../styles/constants';


/**
 * Styles
 */

export const Wrapper = styled.div`
	height: ${({ $height }) => $height}px !important;
	cursor: pointer;
	padding: 3px 5px 0px;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	gap: 10px;

	${({ $isActive, $showBorder }) => ($showBorder === true && $isActive === true ? css`
		border-bottom: 3px solid ${({ theme }) => theme.primaryButton} !important;
 	` : css`
	 	border-bottom: 3px solid transparent;
 	`)}
	svg {
	 	position: relative;
		font-size: 1.4rem;
 	}
	* {
		${({ $isActive }) => ($isActive === true ? css`
		 	color: ${({ theme }) => theme.primaryButton};
	 	` : css`
		 	color: ${({ theme }) => theme.inactiveElement};
	 	`)}
	}
 	${({ $isActive }) => ($isActive !== true && css`
	 	&:hover {
		 	opacity: 0.7;
	 	}
 	`)};
`;

export const Link = styled(LocaleLink)`
	height: ${({ $height }) => $height}px !important;
	text-decoration: none;
	${({ $isActive }) => ($isActive === true ? css`
		color: ${({ theme }) => theme.primaryButton};
	` : css`
		color: ${({ theme }) => theme.inactiveElement};
	`)}
`;

export const Label = styled(Typography)`
	height: auto !important;
`;

export const LabelContainer = styled.div`
	height: auto !important;

	&.expandedTab {
		display: inherit !important;

		@media only screen and (max-width: ${xSmallBreakpoint}em) {
			display: none !important;
		}
	}
`;
